module.exports = __webpack_public_path__ + "media/images/growth_mindset/header-img-485d66f06dc0e67e0578008cd9695275.png";